import { isGroupChat, selectCurrentWaChat } from './redux/TeamInboxSelectors';
import { generateParticipantsNameListThunk } from './redux/TeamInboxThunks';
import { dispatch } from '@/common/state/state-provider';
import { useAppSelector } from '@common/reducers/hooks/store.hook';
import { Typography } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './team-inbox.module.scss';

const ChatParticipantsList = () => {
    const { t } = useTranslation();
    const waChat = useAppSelector(selectCurrentWaChat);

    const participantsDisplayNameList = waChat?.participantsDisplayNameList;

    const [displayParticipants, setDisplayParticipants] = useState('');

    useEffect(() => {
        if (!isGroupChat(waChat) || !waChat?.group?.participants?.length) {
            setDisplayParticipants('');
            return;
        }

        if (!participantsDisplayNameList) {
            setDisplayParticipants(t('teamInbox.loadingGroupParticipants'));
            dispatch(generateParticipantsNameListThunk());
            return;
        }

        setDisplayParticipants(participantsDisplayNameList);
    }, [waChat, participantsDisplayNameList, t]);

    return (
        <Typography
            className={styles.chatHeaderParticipants}
            title={displayParticipants}
        >
            {displayParticipants}
        </Typography>
    );
};

export default memo(ChatParticipantsList);

